import DateFnsUtils from '@date-io/date-fns';
import { Grid } from '@material-ui/core';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import HeaderPage from '~/components/HeaderPage';
import { ApplicationState } from '~/store';
import {
  historicoRequest,
  resetPage,
} from '~/store/ducks/ExibirHistoricoDeManutencaoDasAtividades/actions';
import { Container, SearchButton, StyledTextField } from './styles';
import Table from './Table';

interface State {
  isVerified: boolean;
  consentimentoData: any[];
}

interface StateProps {
  profile: any;
  language: any;
}

type Props = StateProps & State;

const localeMap = {
  ptBR,
};

interface FormProps {
  atividade: string;
  user: string;
}
const ExibirHistoricoDeManutencaoDasAtividades = () => {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = React.useState<Date | null>();

  const [form, setForm] = useState<FormProps>({ atividade: '', user: '' });

  const handleInputChange = useCallback(
    ({ target: { name, value } }: React.ChangeEvent<HTMLInputElement>) => {
      setForm({
        ...form,
        [name]: value,
      });
    },
    [form],
  );

  const historico = useSelector<ApplicationState, any>(
    state => state.ExibirHistoricoDeManutencaoDasAtividades,
  );

  const { company } = useSelector<ApplicationState, any>(state => state.auth);

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };

  const getHistorico = useCallback(() => {
    dispatch(
      historicoRequest({
        pageNo: 0,
        pageSize: 5,
        company: company.country_company_id,
        date: selectedDate ? format(selectedDate as Date, 'dd/MM/yyy') : '',
        atividade: form.atividade ? form.atividade : '',
        user: form.user ? form.user : '',
      }),
    );
    dispatch(resetPage(1));
  }, [
    company.country_company_id,
    dispatch,
    form.atividade,
    form.user,
    selectedDate,
  ]);

  useEffect(() => {
    dispatch(
      historicoRequest({
        pageNo: 0,
        pageSize: 5,
        company: company.country_company_id,
      }),
    );
  }, [company.country_company_id, dispatch]);

  return (
    <Container>
      <HeaderPage pageTitle="Exibir histórico de manutenção das atividades" />

      <div className="content">
        <h1>Filtrar lista de histórico de manutenção</h1>

        <div className="search-event">
          <MuiPickersUtilsProvider
            locale={localeMap['ptBR']}
            utils={DateFnsUtils}
          >
            <div className="PickerLGPD">
              <Grid container justify="space-around">
                <DatePicker
                  clearable
                  clearLabel="Limpar"
                  cancelLabel="Cancelar"
                  disableFuture
                  format="dd/MM/yyyy"
                  label="Data"
                  value={selectedDate ? selectedDate : null}
                  onChange={handleDateChange}
                  animateYearScrolling
                />
              </Grid>
            </div>
          </MuiPickersUtilsProvider>

          <StyledTextField
            onChange={handleInputChange}
            id="atividade"
            label="Atividade"
            name="atividade"
            value={form.atividade}
            variant="outlined"
            className="TextField-lgpd"
          />

          <StyledTextField
            onChange={handleInputChange}
            id="usuario"
            label="Usuário"
            name="user"
            value={form.user}
            variant="outlined"
            className="TextField-lgpd"
          />

          <SearchButton onClick={getHistorico}>Pesquisar</SearchButton>
        </div>
        <h2>Lista de histórico</h2>
        <Table
          ResetPage={historico.resetPage}
          className="table-lgpd"
          getOrderHandleChangePage={(value: number, rowsPerPage: number) =>
            dispatch(
              historicoRequest({
                pageNo: value,
                pageSize: 5,
                company: company.country_company_id,
                date: selectedDate
                  ? format(selectedDate as Date, 'dd/MM/yyy')
                  : '',
                atividade: form.atividade ? form.atividade : '',
                user: form.user ? form.user : '',
              }),
            )
          }
          data={historico.data}
        />
      </div>
    </Container>
  );
};

export default ExibirHistoricoDeManutencaoDasAtividades;
